module.exports = __webpack_public_path__ + "static/media/blue-bullet-point.4cf1e944.svg";